import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDashboard = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M10.8013 12.416C10.8021 12.848 10.4532 13.1984 10.0212 13.2H3.78013C3.34806 13.1992 2.9992 12.8488 3 12.4168V12.416V3.784C2.9992 3.352 3.34886 3.0008 3.78093 3L10.022 3.0104C10.4532 3.012 10.8021 3.3632 10.8013 3.7944V12.416Z",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M21 7.63042C20.9968 8.05842 20.648 8.40242 20.2199 8.40002H13.9789C13.5508 8.40322 13.2019 8.05922 13.1987 7.63122V7.63042V3.78002C13.2011 3.35282 13.55 3.00802 13.9773 3.01042L20.2183 3.00002C20.6464 2.99682 20.9968 3.34162 21 3.76962V7.63042Z",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.8013 20.228C10.7989 20.6568 10.4484 21.0024 10.0196 21L3.77853 20.9896C3.35046 20.9912 3.0024 20.6464 3 20.2184V16.3712C3.0024 15.9432 3.35126 15.5976 3.77933 15.6H3.78013H10.0212C10.4492 15.5976 10.7989 15.9432 10.8013 16.3712V20.228V20.228Z",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.9797 21C13.5476 20.9992 13.1979 20.648 13.1987 20.216V20.2152V11.5848C13.1971 11.1528 13.5468 10.8016 13.9789 10.8H20.2199C20.652 10.8016 21.0016 11.1528 21 11.5848V20.2048C21.0008 20.6368 20.6528 20.9872 20.2207 20.9896L13.9797 21Z",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
const ForwardRef = forwardRef(SvgDashboard);
export { ForwardRef as ReactComponent };
